export const sections = [
    {
        name: 'A - Reitoria',
        keyName: 'a_reitoria',
        arr: [
            [38.73386100102829, -9.160776964439947], 
            [38.73342481362047, -9.160537719726562], 
            [38.73360714173589, -9.159993134005532], 
            [38.73404216042059, -9.16021464699972], 
            [38.73386100102829, -9.160776964439947],
        ],
    },
    {
        name: 'B - Polidesportivo',
        keyName: 'b_polidesportivo',
        arr: [
            [38.733943701833994, -9.162302613258362] ,
            [38.73366542757527, -9.162181913852692] ,
            [38.73372610400982, -9.161953926086426] ,
            [38.73400437803217, -9.16208803653717] ,
            [38.733943701833994, -9.162302613258362] ,
        ],
    },
    {
        name: 'C - Faculdade de Direito',
        keyName: 'c_facDireito',
        arr: [
            [38.73362281047886, -9.161582865979227] ,
            [38.732881493297135, -9.16121708572365] ,
            [38.73292399200197, -9.161048106554658] ,
            [38.7336737967417, -9.161422848701477] ,
            [38.73362281047886, -9.161582865979227] ,
        ],
    },
    {
        name: 'D - Residência Alfredo de Sousa',
        keyName: 'd_residencia',
        arr: [
            [38.73339709065622, -9.162146374583244] ,
            [38.732807796727904, -9.16190537209971] ,
            [38.73270903331524, -9.161660215833194] ,
            [38.7335555821747, -9.162018969655037] ,
            [38.73339709065622, -9.162146374583244] ,
        ],
    },
    {
        name: 'E - Colégio Almada Negreiro',
        keyName: 'e_colegio',
        arr: [
            [38.73308892501802, -9.159654818379577] ,
            [38.732608812434364, -9.161052703857422] ,
            [38.732481180636626, -9.16098028421402] ,
            [38.73208259134106, -9.160752296447754] ,
            [38.732131761269436, -9.160620868206024] ,
            [38.73207762203793, -9.160591699182987] ,
            [38.732109007104675, -9.160491786897182] ,
            [38.732200808345766, -9.160526990890503] ,
            [38.732322962596214, -9.160211740023414] ,
            [38.732498941666066, -9.160310122310392] ,
            [38.73251274151942, -9.160276850743031] ,
            [38.73270135506738, -9.16038698605206] ,
            [38.732973803099384, -9.159586273229449] ,
            [38.73308892501802, -9.159654818379577] ,
        ],
    },
    {
        name: 'F - NOVA IMS',
        keyName: 'f_IMS',
        arr: [
            [38.732200808345766, -9.160526655614374] ,
            [38.73211047472978, -9.160492235438646] ,
            [38.73222776747505, -9.160124798860657] ,
            [38.73213611912868, -9.160043801359045] ,
            [38.73225053200914, -9.159652572035348] ,
            [38.73253113491248, -9.159824922680848] ,
            [38.732510211659815, -9.159883931279175] ,
            [38.73245581117423, -9.159862473607058] ,
            [38.732200808345766, -9.160526655614374] ,
        ],
    },
    {
        name: 'G - Nova IMS/SU',
        keyName: 'g_IMS_SU',
        arr: [
            [38.73247228824877, -9.159264340996733] ,
            [38.732568535211335, -9.159039035439484] ,
            [38.7328991216169, -9.159269705414763] ,
            [38.73313764503531, -9.159500375390044] ,
            [38.733109921959546, -9.15958754718354] ,
            [38.73247228824877, -9.159264340996733] ,  
        ],
    },
    {
        name: '1 - Estacionamento Norte',
        keyName: 'ext1_estacionamento_norte',
        arr: [
            [38.73406296189873, -9.160156846046448] ,
            [38.73459439906484, -9.160455610093178] ,
            [38.73457347641653, -9.160516262054443] ,
            [38.73453581563412, -9.160645008087156] ,
            [38.73460695265086, -9.161047339439392] ,
            [38.73435169596769, -9.161873459815979] ,
            [38.73410899204589, -9.16209876537323] ,
            [38.73400856259565, -9.16208803653717] ,
            [38.73372819629976, -9.161953926086426] ,
            [38.73366516603879, -9.162180908024311] ,
            [38.73393847112484, -9.162302613258362] ,
            [38.73398763977575, -9.1623455286026] ,
            [38.73396671694971, -9.162421971559525] ,
            [38.73360265879565, -9.162372350692747] ,
            [38.733504320929974, -9.162320047616959] ,
            [38.73373238087942, -9.161632061004637] ,
            [38.733945473264036, -9.160889683414155] ,
            [38.7338440212316, -9.160832640726] ,
            [38.73406296189873, -9.160156846046448],
        ],
    },
    {
        name: '2 - Estacionamento Este',
        keyName: 'ext2_estacionamento_este',
        arr: [
            [38.73459459058665, -9.160451889038052] ,
            [38.73406165815966, -9.16015482444757] ,
            [38.734042964759304, -9.160212673858183] ,
            [38.73358592044508, -9.159979820251465] ,
            [38.73307098272661, -9.159711997952627] ,
            [38.733138168112035, -9.159502387046782] ,
            [38.733205121910444, -9.15955066680905] ,
            [38.733230229568626, -9.159470200538605] ,
            [38.73438098776454, -9.160076379775969] ,
            [38.73456510735549, -9.16007101535794] ,
            [38.73457347641653, -9.160162210464444] ,
            [38.734665536023215, -9.160215854644745] ,
            [38.73459459058665, -9.160451889038052] ,
        ],
    },
    {
        name: '3 - Espaço Exterior Central',
        keyName: 'ext3_exterior_central',
        arr: [
            [38.73372819629976, -9.161637425422668] ,
            [38.73362545256539, -9.161582865980478] ,
            [38.73367682445106, -9.161421292210546] ,
            [38.73265837431088, -9.160907696932554] ,
            [38.73306944806264, -9.159712017137736] ,
            [38.73360208414928, -9.159992944111364] ,
            [38.73342690591924, -9.160532355308533] ,
            [38.73386020217593, -9.160777995641494] ,
            [38.733842778280795, -9.160833748098781] ,
            [38.733945794117545, -9.160891771316527] ,
            [38.73372819629976, -9.161637425422668] ,
        ],
    },
    {
        name: '4 - Estacionamento Oeste (NOVA Law e RAS)',
        keyName: 'ext4_estacionamento_oeste',
        arr: [
            [38.7328787215507, -9.161219000816345] ,
            [38.73372819629976, -9.161637425422668] ,
            [38.733506413226394, -9.162318706512451] ,
            [38.732945675592255, -9.162066578865051] ,
            [38.732945675592255, -9.16210949420929] ,
            [38.73281176744642, -9.162039756774902] ,
            [38.73257051900334, -9.161708070457877] ,
            [38.73270785952801, -9.16166123808506] ,
            [38.73280758281282, -9.161905646324158] ,
            [38.733397613731135, -9.162147045135498] ,
            [38.73355662832219, -9.162018299102783] ,
            [38.732709114091975, -9.161658883094788] ,
            [38.732569058292306, -9.161707162857056] ,
            [38.732543950401706, -9.161621332168579] ,
            [38.732523027152816, -9.161320924758911] ,
            [38.73265798200051, -9.160907864570618] ,
            [38.73276992109939, -9.160966873168945] ,
            [38.732919807374756, -9.16104636458175] ,
            [38.7328787215507, -9.161219000816345] ,
        ],
    },
    {
        name: '5 - Estacionamento Exclusivo CAN',
        keyName: 'ext5_estacionamento_CAN',
        arr: [
            [38.73308894038831, -9.159654189542351] ,
            [38.73297367050214, -9.159584190943631] ,
            [38.73270088187538, -9.160386071334585] ,
            [38.73251195749804, -9.16027465111091] ,
            [38.732498092532765, -9.160307014936222] ,
            [38.73232618849538, -9.1602099241791] ,
            [38.7324563036798, -9.159866224861446] ,
            [38.73251033304933, -9.159887643876715] ,
            [38.73253265297183, -9.159825293229176] ,
            [38.73225098065229, -9.15965112911124] ,
            [38.73230853973964, -9.159462093039421] ,
            [38.73245081814474, -9.158984659834772] ,
            [38.732567988383245, -9.15903830401507] ,
            [38.73246892191673, -9.159265255376027] ,
            [38.73311009290048, -9.159588446762712] ,
            [38.73308894038831, -9.159654189542351] ,
        ],
    },
    {
        name: '6 - Estacionamento Sul',
        keyName: 'ext6_estacionamento_sul',
        arr: [
            [38.73145666140659, -9.160037717269205] ,
            [38.731994543872176, -9.159214561677713] ,
            [38.73232419304654, -9.159402538005594] ,
            [38.732133853606065, -9.160044193267822] ,
            [38.73222591635697, -9.160124659538269] ,
            [38.73207736049562, -9.16059136390686] ,
            [38.732130715101086, -9.160620868206024] ,
            [38.7320836375101, -9.160752296447754] ,
            [38.731895326835904, -9.160650372505188] ,
            [38.731857664641474, -9.160462617874146] ,
            [38.731857664641474, -9.160462617874146] ,
            [38.731312060359265, -9.160177187911557] ,
            [38.731384288778614, -9.160031201763019] ,
            [38.731428621596905, -9.160049413134956] ,
            [38.73145666140659, -9.160037717269205] ,
        ] ,
    },
];